import React from 'react';
import { Box, Typography } from '@mui/material';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

/**
 * Shared "Vision Invoice AI" brand lockup — the pale rounded logo tile + wordmark.
 * Mirrors the marketing site's .viai-brand / .viai-logo CSS (brand.pale tile, brand.navy icon
 * via currentColor, brand-ink wordmark), exposed as one reusable component so the app bar,
 * login, and other spots stay in sync.
 *
 * Props:
 *  - nameColor: wordmark color (default brand ink #0f1f3a; pass "inherit" on colored bars).
 *  - logoSize / iconSize / fontSize: sizing overrides.
 *  - showName: hide the wordmark to render just the logo tile.
 *  - onClick / sx: optional passthroughs.
 */
const Brand = ({
  nameColor = '#0f1f3a',
  logoSize = 32,
  iconSize = 19,
  fontSize = 17,
  showName = true,
  onClick,
  sx,
}) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      textDecoration: 'none',
      cursor: onClick ? 'pointer' : 'default',
      ...sx,
    }}
  >
    <Box
      sx={{
        width: logoSize,
        height: logoSize,
        borderRadius: '8px',
        bgcolor: '#B5D4F4', // brand.pale
        color: '#0C447C',   // brand.navy — drives the icon via currentColor
        display: 'grid',
        placeItems: 'center',
        flex: '0 0 auto',
      }}
    >
      <LocalShippingOutlinedIcon sx={{ fontSize: iconSize }} />
    </Box>
    {showName && (
      <Typography
        component="span"
        sx={{ whiteSpace: 'nowrap', fontWeight: 700, fontSize, color: nameColor, lineHeight: 1 }}
      >
        Vision Invoice AI
      </Typography>
    )}
  </Box>
);

export default Brand;
